<template>
  <a-menu
    style="width: 160px"
    mode="inline"
    theme="light"
    :openKeys="openKeys"
    :selectedKeys="selectedKeys"
    @openChange="onOpenChange"
  >
    <a-sub-menu v-for="(item,index) in menuList" :key="item.name">
      <span slot="title">
        <a-icon v-if="item.icon" :type="item.icon" />
        {{ item.title }}
      </span>

      <template v-for="(child,idx) in item.children">
        <a-sub-menu
          v-if="child.children && child.children.length > 0"
          :key="child.name"
        >
          <span slot="title">{{ child.title }}</span>
          <a-menu-item
            v-for="grand in child.children"
            :key="grand.name"
            @click="goRoute(grand.name)"
          >
            {{ grand.title }}
          </a-menu-item>
        </a-sub-menu>

        <a-menu-item
          v-else
          :key="child.name"
          @click="goRoute(child.name)"
        >
          {{ child.title }}
        </a-menu-item>
      </template>
    </a-sub-menu>
  </a-menu>
</template>

<script>
export default {
  name: "MenuNew",
  props: {
    menuList: { type: Array, default: () => [] },
    activeRouteName: { type: String, default: "" }
  },
  data() {
    return {
      selectedKeys: [],
      openKeys: []
    };
  },
  watch: {
    activeRouteName: {
      immediate: true,
      handler(name) {
        if (!name) {
          this.openKeys = [];
          this.selectedKeys = [];
          return;
        }
        this.selectedKeys = [name];

        const keys = [];
        this.menuList.forEach(item => {
          item.children?.forEach(child => {
            if (child.children?.some(g => g.name == name)) {
              keys.push(item.name, child.name);
            } else if (child.name == name) {
              keys.push(item.name);
            }
          });
        });
        this.openKeys = keys;
      }
    }
  },
  methods: {
    goRoute(name) {
      this.selectedKeys = [name];
      this.$emit("onClick", name);
    },
    onOpenChange(keys) {
      this.openKeys = keys;
    }
  }
};
</script>

<style scoped>
::v-deep .ant-menu-item-selected {
  color: #2CBD9C !important;
}
::v-deep .ant-menu-submenu-selected {
  color: #2CBD9C !important;
}
::v-deep .ant-menu-submenu-open > .ant-menu-submenu-title {
  color: #2CBD9C !important;
}
::v-deep .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: rgba(44, 189, 156, 0.1) !important;
  color: #2CBD9C !important;
}
::v-deep .ant-menu-inline .ant-menu-item::after {
  border-right: 3px solid #2CBD9C;
}
::v-deep .ant-menu-submenu-title:hover {
  color: #2CBD9C !important;
}
::v-deep .ant-menu-item:hover {
  color: #2CBD9C !important;
}
::v-deep .ant-menu-item:active {
  background: rgba(44, 189, 156, 0.1) !important;
}
::v-deep .ant-menu-submenu-title:active {
  background: rgba(44, 189, 156, 0.1) !important;
}
::v-deep .ant-menu-inline .ant-menu-item {
  padding-left: 45px !important;
}
::v-deep .ant-menu-inline .ant-menu-submenu-title {
  padding-left: 45px !important;
}
</style>